<template>
  <div class="audit-type-selector" :class="{ 'audit-type-selector--wrap': wrap }">
    <div
      v-for="option in options"
      :key="option.value"
      class="form-check form-check-inline audit-type-option"
      :class="{ 'audit-type-option--legacy': option.legacy }"
    >
      <input
        class="form-check-input"
        type="radio"
        :name="inputName"
        :id="inputId(option.value)"
        :value="option.value"
        v-model="selectedValue"
        :disabled="disabled || option.disabled"
      />
      <label class="form-check-label" :for="inputId(option.value)">
        {{ option.label }}
      </label>
    </div>
    <span v-if="showBadge && normalizedValue === '혼합'" class="badge bg-warning text-dark ms-2">
      표준별 상세 필수
    </span>
  </div>
</template>

<script>
import {
  AUDIT_TYPE_VALUES,
  auditTypeLabel,
  getAuditTypeOptions,
  isLegacyTransferAuditType,
  normalizeAuditType
} from '@/utils/auditTypes'

export default {
  name: 'AuditTypeSelector',
  data() {
    return {
      instanceId: `audit_type_${Math.random().toString(36).slice(2, 9)}`
    }
  },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: 'audit_type'
    },
    idPrefix: {
      type: String,
      default: 'audit_type'
    },
    includeLegacyTransfer: {
      type: Boolean,
      default: false
    },
    showBadge: {
      type: Boolean,
      default: true
    },
    wrap: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  computed: {
    normalizedValue() {
      return normalizeAuditType(this.modelValue)
    },
    selectedOptionValue() {
      if (this.normalizedValue === AUDIT_TYPE_VALUES.TRANSFER_SURVEILLANCE) {
        return AUDIT_TYPE_VALUES.SURVEILLANCE
      }
      if (this.normalizedValue === AUDIT_TYPE_VALUES.TRANSFER_RENEWAL) {
        return AUDIT_TYPE_VALUES.RENEWAL
      }
      return this.normalizedValue
    },
    inputName() {
      return `${this.name}_${this.instanceId}`
    },
    selectedValue: {
      get() {
        return this.selectedOptionValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    options() {
      const baseOptions = getAuditTypeOptions({
        includeLegacyTransfer: this.includeLegacyTransfer
      })
      if (isLegacyTransferAuditType(this.normalizedValue)) {
        return baseOptions
      }
      if (
        this.normalizedValue &&
        !baseOptions.some((option) => option.value === this.normalizedValue)
      ) {
        return [
          ...baseOptions,
          {
            value: this.normalizedValue,
            label: auditTypeLabel(this.normalizedValue),
            legacy: true
          }
        ]
      }
      return baseOptions
    }
  },
  methods: {
    inputId(value) {
      return `${this.idPrefix}_${this.instanceId}_${this.safeId(value)}`
    },
    safeId(value) {
      return String(value || '')
        .replace(/[^a-zA-Z0-9가-힣_-]/g, '_')
        .replace(/_+/g, '_')
    }
  }
}
</script>

<style scoped>
.audit-type-selector {
  width: 100%;
  min-width: 0;
}

.audit-type-selector--wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem 0.5rem;
}

.audit-type-option {
  margin-right: 0.75rem;
  white-space: nowrap;
}

.audit-type-option--legacy label {
  color: #6c757d;
}

@media print {
  .audit-type-option .form-check-input {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
}
</style>
